export const getBenchmarkTooltipTitle = (benchmarkTooltip) => {
  if (benchmarkTooltip && benchmarkTooltip !== "")
    return `The benchmark is ${benchmarkTooltip}`
  else {
    return ''
  }
}